module.exports = __webpack_public_path__ + "static/img/smoke.dc425c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/sprites/smoke.jpg
// module id = 596
// module chunks = 1